import jApi from './jApi';

export default {
  login(authData) {
    const api = jApi.loginApi();
    return api.post('auth/login', authData)
      .then(res => res.data);
  },
  loginLdap(authData) {
    const api = jApi.loginApi();
    return api.post('auth/other-login', authData)
      .then(res => res.data);
  },
  refreshToken(req) {
    const api = jApi.loginApi();
    return api.post('auth/refresh', req)
      .then(res => res.data);
  },
  loginV2(authData) {
    const api = jApi.loginApi();
    return api.post('auth-service/v2/auth/login', authData)
      .then(res => res.data);
  },
  getKeyRSA() {
    const api = jApi.loginApi();
    return api.get('auth-service/generate-key')
      .then(res => res.data);
  },
  refreshTokenV2() {
    const api = jApi.refreshTokenApi();
    const refreshToken = JSON.parse(localStorage.getItem('refresh_token')).value;
    return api.get(`auth-service/refresh-token?refresh_token=${refreshToken}`)
      .then(res => res.data);
  },
  logout() {
    const api = jApi.generateApi();
    return api.get('auth-service/logout')
      .then(res => res.data);
  },
  requestOtpLogin(req) {
    const api = jApi.generateApi();
    return api.post('auth-service/v2/auth/login-otp/request', req)
      .then(res => res.data);
  },
  // Challenge calls carry no Bearer header: generateApi() would send a 401 to /logout.
  verifyLoginChallenge(challengeId, otp) {
    const api = jApi.loginApi();
    return api.post(`auth-service/v2/auth/login-challenges/${encodeURIComponent(challengeId)}/verification`, { otp })
      .then(res => res.data);
  },
  resendLoginChallenge(challengeId) {
    const api = jApi.loginApi();
    return api.post(`auth-service/v2/auth/login-challenges/${encodeURIComponent(challengeId)}/otps`, {})
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiGateway.js